module.exports = __webpack_public_path__ + "static/media/8.25417cf3.jpg";